import numeral from 'numeral';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Component represents "total matches" counter
 */
export default function Matches({ itemsNum }) {
    return (
        <span className="search-resultCounter">
            {numeral(itemsNum).format(0, 0)}
        </span>
    );
}

Matches.propTypes = {
    /**
     * Number to display
     */
    itemsNum: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/Common/Matches.jsx